import React from 'react';
import Index from './index';

export default () => <Index language="nl" />;
